module.exports = __webpack_public_path__ + "static/media/IconExamMath.b248e94a.svg";